import React from 'react';

function PatientDetailSkeleton() {
    return (
        <div className="patient-detail-skeleton" aria-hidden="true">
            <div className="patient-detail-skeleton__summary">
                <div className="patient-files-skeleton-block patient-detail-skeleton__avatar" />
                <div className="patient-detail-skeleton__meta">
                    <div className="patient-files-skeleton-block patient-files-skeleton-block--title" />
                    <div className="patient-files-skeleton-block patient-files-skeleton-block--line-medium" />
                    <div className="patient-files-skeleton-block patient-files-skeleton-block--line-short" />
                </div>
                <div className="patient-detail-skeleton__status">
                    <div className="patient-files-skeleton-block patient-files-skeleton-block--pill" />
                    <div className="patient-files-skeleton-block patient-files-skeleton-block--pill" />
                </div>
            </div>

            <div className="patient-detail-skeleton__contacts">
                {Array.from({ length: 3 }).map((_, index) => (
                    <div key={`contact-${index}`} className="patient-files-skeleton-block patient-detail-skeleton__contact-card" />
                ))}
                <div className="patient-files-skeleton-block patient-detail-skeleton__address-card" />
            </div>

            <div className="patient-detail-skeleton__actions">
                {Array.from({ length: 4 }).map((_, index) => (
                    <div key={`action-${index}`} className="patient-files-skeleton-block patient-files-skeleton-block--action-pill" />
                ))}
            </div>

            <div className="patient-detail-skeleton__tabs">
                <div className="patient-detail-skeleton__nav">
                    {Array.from({ length: 5 }).map((_, index) => (
                        <div key={`tab-${index}`} className="patient-files-skeleton-block patient-files-skeleton-block--tab-pill" />
                    ))}
                </div>
                <div className="patient-detail-skeleton__content">
                    <div className="patient-files-skeleton-panel__header">
                        <div className="patient-files-skeleton-panel__heading">
                            <div className="patient-files-skeleton-block patient-files-skeleton-block--title" />
                            <div className="patient-files-skeleton-block patient-files-skeleton-block--subtitle" />
                        </div>
                        <div className="patient-files-skeleton-block patient-files-skeleton-block--button" />
                    </div>
                    {Array.from({ length: 3 }).map((_, rowIndex) => (
                        <div key={`detail-field-row-${rowIndex}`} className="patient-files-skeleton-field-grid">
                            {Array.from({ length: 3 }).map((__, colIndex) => (
                                <div key={`detail-field-${rowIndex}-${colIndex}`} className="patient-files-skeleton-field">
                                    <div className="patient-files-skeleton-block patient-files-skeleton-block--label" />
                                    <div className="patient-files-skeleton-block patient-files-skeleton-block--input" />
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default PatientDetailSkeleton;
